import { createFileRoute } from "@tanstack/react-router";
import { comparisonRoute } from "@/lib/seo/comparisonRoute";
import { getComparison } from "@/lib/seo/comparisons";

export const Route = createFileRoute("/jamfor/film-pa-abonnemang-vs-filmbyra")(
  comparisonRoute(getComparison("film-pa-abonnemang-vs-filmbyra")),
);
